module.exports = __webpack_public_path__ + "static/img/8.74c2da20.png";